module.exports = __webpack_public_path__ + "media/Apple_Health_badge_FR_blk_sRGB-a90e446d.svg";